import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n";
// import reportWebVitals from "./reportWebVitals";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Header } from "./Components/Header/Header";
import { Footer } from "./Components/Footer/Footer";
import { MultiStepFormProvider } from "./Components/Provider/MultiStepFormContext";
import { AlternateProductProvider } from "./Components/User/AlternateProductContext";
import { t } from "i18next";
import { Navbar } from "./Components/Navbar/Navbar";

// Create a new QueryClient instance
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <div className="app">
        <Header />
        {/* <Navbar /> */}
        <main>
          <AlternateProductProvider>
            <MultiStepFormProvider>
              <App />
              {/* <h2 style={{ fontSize: "40px", marginTop: "80px" }}>
                Hello world!!!
              </h2> */}
            </MultiStepFormProvider>
          </AlternateProductProvider>
        </main>
        <Footer />
      </div>
    </QueryClientProvider>
  </React.StrictMode>
);

// reportWebVitals();
